import React, { useState, useEffect, useCallback, useRef } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Icon, Divider, Dropdown, Button, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  DivCurso,
  Input,
  Div,
  DivIcon,
  DivConteudo,
  Label,
  DivTitulo,
  Select,
} from "./styled";
import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
// import { Checkbox } from "@material-ui/core";
// import VerTeste from "../../../../../components/VerTeste";
import { isAuthAdmin } from "../../../../../services/auth";
import { systemLogs } from "../../../../../services/system_logs";

const CombosPlataformaEditar = (props) => {
  const [nomeCombo, setNomeCombo] = useState("");
  const [combo, setCombo] = useState([]);
  const [comboTitulo, setComboTitulo] = useState("");
  const validadeCombo = useRef([]);
  const cursoData = useRef({
    id: "",
    nome: "",
    tempo: "",
    liberar: "",
  });
  const [optionsCurso, setOptionsCurso] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuth();
    loadCursos();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadCursos = async () => {
    await api
      .get("/cursos-ids")
      .then((res) => {
        const newOptions = res.data.map((cur) => ({
          ...optionsCurso,
          key: cur.id,
          text: cur.curso,
          value: cur.id,
        }));
        setOptionsCurso(newOptions);
      })
      .catch((err) => {});
  };

  const create = useCallback(() => {
    const newCombo = combo.filter((curso) => curso.id === cursoData.current.id);
    if (newCombo.length == 0) {
      setCombo([
        ...combo,
        {
          id: cursoData.current.id,
          titulo: cursoData.current.nome,
          validade: cursoData.current.tempo,
          liberar: cursoData.current.liberar,
        },
      ]);
    } else {
      swal("Erro ao adicionar curso", "Este curso já está no combo", "error");
    }
  }, [combo]);

  const deleteCurso = useCallback(
    (id) => {
      const newCombo = combo.filter((curso) => curso.id !== id);
      setCombo(newCombo);
    },
    [combo]
  );

  const handleInput = useCallback((e) => {
    const { name, value } = e.target;
    cursoData.current[name] = value;
  }, []);

  const handleInputCheckbox = useCallback((e) => {
    const { name, checked } = e.target;
    cursoData.current[name] = checked;
  }, []);

  const handleInputDrop = useCallback((nome, id) => {
    cursoData.current["nome"] = nome;
    cursoData.current["id"] = id;
  }, []);

  const dataLiberacao = (valor) => {
    return valor == 1 ? true : false;
  };

  const handleSubmit = async () => {
    combo.sort((cursoA, cursoB) => cursoA.id - cursoB.id);

    const newCursos = combo.map((cursos) => cursos.id).join(",");
    const newValidade = combo.map((cursos) => cursos.validade).join(",");
    const newDataLiberacao = combo
      .map((cursos) => (cursos.liberar == 1 ? 1 : 0))
      .join(",");

    const payload = {
      id_combo: comboTitulo,
      cursos: newCursos,
      validades: newValidade,
      datas_liberacao: newDataLiberacao,
      id_demonstracao: null,
    };

    await api
      .post(`/admin/combo`, payload)
      .then(async (res) => {
        await systemLogs(
          "ead/combos",
          `criou o combo de id=${res.data.id_combo}`
        );

        swal("Sucesso!", "Criação de combo bem sucedida", "success").then(
          (res) => {
            window.location.href = "/admin/ead/combos";
          }
        );
      })
      .catch((err) => {
        console.error(err);
        swal(
          "Erro ao criar o combo",
          "Por favor, insira preencha todos os campos necessários",
          "error"
        );
      });
  };

  const handleInputModify = useCallback(
    (value, name, index) => {
      if (value == true) {
        const newCombo = combo;
        newCombo[index][name] = 1;
        setCombo([...newCombo]);
      } else {
        if (value == false) {
          const newCombo = combo;
          newCombo[index][name] = 0;
          setCombo([...newCombo]);
        } else {
          const newCombo = combo;
          newCombo[index][name] = value;
          setCombo([...newCombo]);
        }
      }
    },
    [combo]
  );

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Criar COMBOS</Title>

          <DivTitulo>
            <Label>Combo presencial?</Label>
            <DivConteudo>
              <input type="checkbox" />
            </DivConteudo>
          </DivTitulo>

          <DivTitulo>
            <Label>Nome do curso </Label>
            <DivConteudo>
              <Dropdown
                placeholder="Selecione o curso"
                fluid
                search
                selection
                options={optionsCurso}
                onChange={(e, data) => setComboTitulo(data.value)}
              />
            </DivConteudo>
          </DivTitulo>
          {combo.map((curso, index) => (
            <>
              <DivCurso>
                <Div>
                  <Label>Curso</Label>
                  <DivConteudo>{curso.titulo}</DivConteudo>
                </Div>
                <Div>
                  <Label>Tempo de acesso</Label>
                  <DivConteudo>
                    <Input
                      type="text"
                      value={curso.validade}
                      onChange={(e) =>
                        handleInputModify(e.target.value, "validade", index)
                      }
                    />
                  </DivConteudo>
                </Div>
                <Div>
                  <Label>Liberar mais tarde</Label>
                  <DivConteudo>
                    <input
                      type="checkbox"
                      checked={dataLiberacao(curso.liberar)}
                      onClick={(e) =>
                        handleInputModify(e.target.checked, "liberar", index)
                      }
                    />
                  </DivConteudo>
                </Div>
                <DivIcon>
                  <Icon
                    link
                    name="remove"
                    color="red"
                    size="big"
                    onClick={() => deleteCurso(curso.id)}
                  />
                </DivIcon>
              </DivCurso>
              <Divider inverted />
            </>
          ))}
          <Divider inverted />
          <DivCurso>
            <Div>
              <Label>Nome do curso </Label>
              <Dropdown
                placeholder="Selecione o curso"
                fluid
                search
                selection
                options={optionsCurso}
                onChange={(e, data) =>
                  handleInputDrop(e.target.innerText, data.value)
                }
              />
            </Div>
            <Div>
              <Label>Tempo de acesso </Label>
              <DivConteudo>
                <Input type="number" name="tempo" onChange={handleInput} />
              </DivConteudo>
            </Div>
            <Div>
              <Label>Liberar mais tarde</Label>
              <DivConteudo>
                <input
                  type="checkbox"
                  name="liberar"
                  onClick={handleInputCheckbox}
                />
              </DivConteudo>
            </Div>
            <DivIcon>
              <Icon
                link
                name="plus"
                color="green"
                size="big"
                onClick={() => create()}
              />
            </DivIcon>
          </DivCurso>
          <Button onClick={handleSubmit}>
            <Icon name="save" />
            Salvar
          </Button>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CombosPlataformaEditar);
